import { IIntersectionStateData } from "@types"
import { protectedApi } from "store/Api"


const interSectionStateVectorApi = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        fetchInterSectionStateVector: builder.query<IIntersectionStateData[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `data/intersection_state_vector`,
                }
            },
        }),
    }),
})

export const { useFetchInterSectionStateVectorQuery } = interSectionStateVectorApi
